import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CustomSelect, HeaderInput, HeaderTemplate } from 'web-library';
import { AUTHORITY_NAMES } from 'web-library/models/AuthorityFunctions';
import { useGetUserAuthorities } from '../../api-refactored/user/useGetUserAuthorities';
import MedicalConditionConfiguration from '../../modules/admin/components/AccessArrangementConfig/MedicalConditionConfiguration';
import RequestTypeConfiguration from '../../modules/admin/components/AccessArrangementConfig/RequestTypeConfiguration';

enum AccessArrangementDropdown {
  MEDICAL_CONDITIONS = '0',
  REQUEST_TYPES = '1',
}

const AccessArrangementConfigurationDetails = () => {
  const { t } = useTranslation();
  const [selectedDropdown, setSelectedDropdown] = useState<string>();

  const { data: userAuthoritiesData = [] } = useGetUserAuthorities();
  const isEnableCreate = userAuthoritiesData.includes(
    AUTHORITY_NAMES.CP_ADMIN_ACCESS_ARRANGEMENTS_CONFIGURATION_CREATE
  );
  const isEnableDelete = userAuthoritiesData.includes(
    AUTHORITY_NAMES.CP_ADMIN_ACCESS_ARRANGEMENTS_CONFIGURATION_DELETE
  );

  return (
    <>
      <HeaderTemplate>
        <HeaderInput
          label={t('admin->>AccessArrangementConfiguration.DropdownType')}
          input={
            <CustomSelect
              id="inputSelect-dropdownType"
              isHeader
              displayEmpty
              onChange={(event) => setSelectedDropdown(event.target.value as string)}
              menuItems={[
                {
                  children: 'Medical Conditions',
                  value: AccessArrangementDropdown.MEDICAL_CONDITIONS,
                  key: 'k-medicalConditions',
                },
                {
                  children: 'Request Types',
                  value: AccessArrangementDropdown.REQUEST_TYPES,
                  key: 'k-requestTypes',
                },
              ]}
              variant="filled"
              placeholder={t('admin->>AccessArrangementConfiguration.SelectDropdownType')}
            />
          }
        />
      </HeaderTemplate>
      {selectedDropdown &&
        (selectedDropdown === AccessArrangementDropdown.MEDICAL_CONDITIONS ? (
          <MedicalConditionConfiguration
            isEnableCreate={isEnableCreate}
            isEnableDelete={isEnableDelete}
          />
        ) : (
          <RequestTypeConfiguration
            isEnableCreate={isEnableCreate}
            isEnableDelete={isEnableDelete}
          />
        ))}
    </>
  );
};

export default AccessArrangementConfigurationDetails;
